var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "message-list--item-appointment-info" }, [
    _c(
      "div",
      { staticClass: "message-list--item-appointment-info-dates" },
      _vm._l(_vm.data.potentialDates, function(potentialDate) {
        return _c(
          "span",
          {
            key: potentialDate.id,
            staticClass: "message-list--item-appointment-info-date"
          },
          [
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.formatDate(potentialDate)) + "\n\t\t"
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.reasons
      ? _c(
          "div",
          { staticClass: "message-list--item-appointment-info-reasons" },
          [_vm._v(_vm._s(_vm.reasons))]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }